import { render } from "./EmailPreferencesView.vue?vue&type=template&id=0f4a0150"
import script from "./EmailPreferencesView.vue?vue&type=script&lang=js"
export * from "./EmailPreferencesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__